import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import {
  Sensor,
} from 'src/api'
import { useApiInstance } from './useApiInstance'

interface RequestParams {
  uniqueId: string;
  options?: Omit<
    UseQueryOptions<unknown, Error, Sensor>,
    'queryKey' | 'queryFn'
  >;
}

export const useSensorFirmware = ({
  uniqueId,
  options,
}: RequestParams) => {
  const api = useApiInstance()

  return useQuery<unknown, Error, Sensor>(
    [Entities.Sensors, `get-firmware-version-${uniqueId}`],
    async () => {
      const { data } = await api.v1AdminSensorsUniqueIdFirmwareVersionGet(uniqueId)
      return data as Sensor
    },
    { ...options },
  )
}
